import { useNavigate } from "react-router-dom";
import { CaretDown, User, Gear, SignOut } from "@phosphor-icons/react";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuLabel, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { useAuth } from "@/context/AuthContext";
import { ROLE_LABELS } from "@/lib/nav";

export function UserMenu() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const initials = (user?.name || "U").split(" ").map((p) => p[0]).join("").slice(0, 2).toUpperCase();

  const onLogout = async () => { await logout(); navigate("/login"); };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="user-menu-trigger"
          title={user?.name ? `${user.name} — ${ROLE_LABELS[user?.role] || user?.role}` : "Account"}
          className="flex items-center gap-2 border border-transparent px-1.5 py-1 transition-colors hover:border-border"
        >
          <span className="flex h-8 w-8 items-center justify-center bg-primary font-mono text-xs font-bold text-primary-foreground">{initials}</span>
          <span className="hidden max-w-[140px] text-left xl:block">
            <span className="block max-w-[140px] truncate text-sm font-medium leading-tight text-foreground">{user?.name}</span>
            <span className="block font-mono text-[10px] uppercase tracking-wide text-muted-foreground">{ROLE_LABELS[user?.role] || user?.role}</span>
          </span>
          <CaretDown className="hidden h-3.5 w-3.5 text-muted-foreground xl:block" weight="bold" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56 rounded-none">
        <DropdownMenuLabel className="font-normal">
          <p className="text-sm font-medium text-foreground">{user?.name}</p>
          <p className="font-mono text-[11px] text-muted-foreground">{user?.email}</p>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem data-testid="menu-profile" onClick={() => navigate("/admin/my-account")} className="cursor-pointer gap-2">
          <User className="h-4 w-4" weight="bold" /> My Account
        </DropdownMenuItem>
        <DropdownMenuItem data-testid="menu-admin" onClick={() => navigate("/admin")} className="cursor-pointer gap-2">
          <Gear className="h-4 w-4" weight="bold" /> Administration
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem data-testid="menu-logout" onClick={onLogout} className="cursor-pointer gap-2 text-destructive focus:text-destructive">
          <SignOut className="h-4 w-4" weight="bold" /> Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
